export enum FilterOptionsEnum {
    StartsWith = 1,
    EndsWith,
    Contains,
    IsGreaterThan,
    IsGreaterThanOrEqualTo,
    IsLessThan,
    IsLessThanOrEqualTo,
    IsEqualTo
}